import { render, staticRenderFns } from "./CreateModule.vue?vue&type=template&id=458c4734&scoped=true"
import script from "./CreateModule.vue?vue&type=script&lang=js"
export * from "./CreateModule.vue?vue&type=script&lang=js"
import style0 from "./CreateModule.vue?vue&type=style&index=0&id=458c4734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c4734",
  null
  
)

export default component.exports